import React from 'react'

import { useTranslation } from '@mc/i18n'
import { useStaticData } from '@mc/static-data-react'
import { Separator } from '@mc/design-system'

import { Category } from 'types/data'
import { articleCategoryPath } from 'libs/paths'

import Link from 'components/Link'

export const OtherCategories = () => {
  const { t } = useTranslation('@mc/next')
  const { articleCategories } = useStaticData<{
    articleCategories: Array<Category>
  }>()

  return (
    <aside className='d-none d-sm-block mc-mt-12'>
      <h2 className='mc-text-h8 mc-text--uppercase mc-mb-2'>
        {t('articlesCategories.otherCategories.title')}
      </h2>
      <Separator />
      {articleCategories.map(({ name, slug }) => (
        <Link
          className='mc-text-h8 mc-text--uppercase d-block mc-py-2'
          href={articleCategoryPath(slug)}
          key={slug}
          passHref
        >
          {name}
        </Link>
      ))}
    </aside>
  )
}
